import './LandingPage.css';
import LandImage from './LandingPage.png';

export default function LandingPage() {
    return (
        <div className="wms-land-container">
            <div className="wms-land-msg">Welcome to eComp portal</div>
            <img className="wms-land-logo" src={LandImage} alt="WMS 404 Logo" />
        </div>);
}